/**
 * @generated SignedSource<<e3c3a8d4a55cecfd8cc713f9eed425e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MusicParseStatus = "ERROR" | "IN_PROGRESS" | "NOT_STARTED" | "SKIPPED" | "SUCCESS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PieceEditBody_piece$data = {
  readonly id: string;
  readonly name: string | null;
  readonly sheets: ReadonlyArray<{
    readonly id: string;
    readonly noteFinderUserConfirmation: ReadonlyArray<{
      readonly id: string;
      readonly status: MusicParseStatus;
    }>;
    readonly barFinderUserConfirmation: ReadonlyArray<{
      readonly id: string;
      readonly status: MusicParseStatus;
      readonly data: {
        readonly deleted_mask_storage_names?: ReadonlyArray<string>;
      } | null;
    }>;
  }>;
  readonly " $fragmentType": "PieceEditBody_piece";
};
export type PieceEditBody_piece$key = {
  readonly " $data"?: PieceEditBody_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceEditBody_piece">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceEditBody_piece",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicSheet",
      "kind": "LinkedField",
      "name": "sheets",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "noteFinderUserConfirmation",
          "args": [
            {
              "kind": "Literal",
              "name": "step_type",
              "value": "NOTE_USER_CONFIRMATION"
            }
          ],
          "concreteType": "MusicParseStep",
          "kind": "LinkedField",
          "name": "steps",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": "steps(step_type:\"NOTE_USER_CONFIRMATION\")"
        },
        {
          "alias": "barFinderUserConfirmation",
          "args": [
            {
              "kind": "Literal",
              "name": "step_type",
              "value": "BAR_FINDER_USER_CONFIRMATION"
            }
          ],
          "concreteType": "MusicParseStep",
          "kind": "LinkedField",
          "name": "steps",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "data",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "deleted_mask_storage_names",
                      "storageKey": null
                    }
                  ],
                  "type": "MusicParseStepDataBarFinderUserConfirmation",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "steps(step_type:\"BAR_FINDER_USER_CONFIRMATION\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};
})();

(node as any).hash = "b0042a6525cecc4cadcb96acf237f40c";

export default node;
